import React from 'react';
import { Card, Col, Divider, message, Row, Space, Typography, Input, Button, Tooltip } from 'antd';
import { CopyOutlined, ShopOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import '../../styles/index.scss';
const { Text, Paragraph } = Typography;
const DetailsCard = ({ details, type, retailIds, setRetailIds }) => {
  const addRetailId = () => {
    setRetailIds([...retailIds, ""]);
  };

  const removeRetailId = (index) => {
    if (retailIds.length > 1) {
      const newRetailIds = retailIds.filter((_, i) => i !== index);
      setRetailIds(newRetailIds);
    }
  };

  const updateRetailId = (index, value) => {
    const newRetailIds = [...retailIds];
    newRetailIds[index] = value.trim() === "" ? null : value;
    setRetailIds(newRetailIds);
  };

  if (type === "impression") {
    details.supportMeasurements = [{ label: "Impressions" }];
  } else if (type === "publisher") {
    details.supportMeasurements = [{ label: "Page Views" }];
  }
  return (
    <Card 
      title="TAG DETAILS"
      className="tags-card"
    >
      <Row gutter={[24, 24]}>
        <Col xs={24} sm={12} md={8}>
          <Space direction="vertical" size={0}>
            <Text type="secondary">Tag ID</Text>
            <Space direction="horizontal">
              <Text
                className="tags-details__text-break"
              >
                {details.appId}
              </Text>
              <CopyOutlined
                role="button"
                tabIndex={0}
                aria-label="Copy tag ID"
                onClick={() => {
                  navigator.clipboard.writeText(details.appId);
                  message.info('Tag ID copied to clipboard');
                }}
              />
            </Space>
          </Space>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Space direction="vertical" size={0}>
            <Text type="secondary">Advertiser</Text>
            <Text
              className="tags-details__text-break"
            >
              {details.advertiser}
            </Text>
          </Space>
        </Col>
        {type === "measurement" && (
          <Col xs={24} sm={12} md={8}>
            <Space direction="vertical" size={0}>
              <Text type="secondary">Cart Platform</Text>
              <Text
                className="tags-details__text-break"
              >
                {details.cart}
              </Text>
            </Space>
          </Col>
        )}
        {type === "publisher" && (
          <Col xs={24} sm={12} md={8}>
            <Space direction="vertical" size={0}>
              <Text type="secondary">Domain</Text>
              <Text
                className="tags-details__text-break"
              >
                {details.publisherDomain}
              </Text>
            </Space>
          </Col>
        )}
        {type === "impression" && (
          <Col xs={24} sm={12} md={8}>
            <Space direction="vertical" size={0}>
              <Text type="secondary">Platform</Text>
              <Text
                className="tags-details__text-break"
              >
                {details.impressionEnvironments
                  ? details.impressionEnvironments
                  : details.dsp}
              </Text>
            </Space>
          </Col>
        )}
        <Col span={24}>
          <Space direction="vertical" size={8}>
            <Text type="secondary">Supported Measurements</Text>
            <Row gutter={[16, 8]}>
              {details.supportMeasurements.map(measurement => (
                <Col key={measurement.label}>
                  <Text
                    className="tags-details__measurement-tag"
                  >
                    {measurement.label}
                  </Text>
                </Col>
              ))}
            </Row>
          </Space>
        </Col>
        <Col span={24}>
          <Divider className="tags-details__divider" />
          <Space direction="vertical" size={12} className="tags-details__retail-ids-container">
            <Space align="center">
              <Tooltip title="Retail IDs are unique identifiers used to track and identify specific retail locations or stores in your marketing campaigns. Each ID helps associate campaign performance data with individual retail outlets.">
                <ShopOutlined className="tags-details__icon-tooltip" />
              </Tooltip>
              <Text type="secondary" strong>Retail IDs</Text>
              <Button
                type="text"
                icon={<PlusOutlined />}
                size="small"
                onClick={addRetailId}
                className="tags-details__add-button"
              >
                Add ID
              </Button>
            </Space>
            <div className="tags-details__retail-ids-wrapper">
              {retailIds.map((retailId, index) => (
                <div key={index} className="tags-details__retail-id-row">
                  <Input
                    placeholder={`Retail ID ${index + 1}`}
                    value={retailId || ""}
                    onChange={(e) => updateRetailId(index, e.target.value)}
                    className="tags-details__retail-id-input"
                  />
                  {retailIds.length > 1 && (
                    <Button
                      type="text"
                      icon={<DeleteOutlined />}
                      size="small"
                      aria-label={`Remove retail ID ${index + 1}`}
                      onClick={() => removeRetailId(index)}
                      className="tags-details__delete-button"
                    />
                  )}
                </div>
              ))}
            </div>
          </Space>
        </Col>
      </Row>
    </Card>
  );
};

export default DetailsCard;
